<template>
  <div class="daily-payment-data">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item label="统计日期">
          <el-date-picker
            v-model="searchForm.stat_date"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            clearable
          />
        </el-form-item>
        
        <el-form-item label="客户名称">
          <el-input
            v-model="searchForm.customer_name"
            placeholder="请输入客户名称"
            clearable
          />
        </el-form-item>
        
        <el-form-item label="收费项目">
          <el-input
            v-model="searchForm.charge_item_name"
            placeholder="请输入收费项目"
            clearable
          />
        </el-form-item>
        
        <el-form-item label="订单类型">
          <el-select
            v-model="searchForm.order_type"
            placeholder="请选择订单类型"
            clearable
          >
            <el-option label="收款" value="收款" />
            <el-option label="红冲" value="红冲" />
            <el-option label="预收款" value="预收款" />
            <el-option label="押金" value="押金" />
            <el-option label="冲销" value="冲销" />
          </el-select>
        </el-form-item>
        
        <el-form-item label="结算方式">
          <el-input
            v-model="searchForm.payment_method"
            placeholder="请输入结算方式"
            clearable
          />
        </el-form-item>
        
        <el-form-item label="综合期间">
          <el-select
            v-model="searchForm.period_type"
            placeholder="请选择综合期间"
            clearable
          >
            <el-option label="历史" value="历史" />
            <el-option label="当期" value="当期" />
            <el-option label="预收" value="预收" />
          </el-select>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset">重置</el-button>
          <el-button type="success" @click="handleExport">导出Excel</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    
    <!-- 数据表格 -->
    <el-card class="table-card" shadow="never">
      <el-table
        :data="tableData"
        v-loading="loading"
        border
        stripe
        style="width: 100%"
        :height="tableHeight"
      >
        <el-table-column prop="stat_date" label="统计日期" width="120" />
        <el-table-column prop="pindex_name" label="项目名称" width="180" show-overflow-tooltip />
        <el-table-column prop="customer_name" label="客户名称" width="150" show-overflow-tooltip />
        <el-table-column prop="house_address" label="房产地址" width="200" show-overflow-tooltip />
        <el-table-column prop="charge_period" label="收费周期" width="220" show-overflow-tooltip />
        <el-table-column prop="bill_no" label="收据编号" width="150" show-overflow-tooltip />
        <el-table-column prop="charge_item_name" label="收费项目" width="150" show-overflow-tooltip />
        <el-table-column prop="payment_method" label="结算方式" width="120" show-overflow-tooltip />
        <el-table-column prop="order_type" label="订单类型" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getOrderTypeTag(scope.row.order_type)" size="small">
              {{ scope.row.order_type }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="金额" width="120" align="right">
          <template slot-scope="scope">
            <span :class="{ 'text-danger': scope.row.amount < 0 }">
              ¥{{ formatMoney(scope.row.amount) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="period_type" label="综合期间" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getPeriodTypeTag(scope.row.period_type)" size="small">
              {{ scope.row.period_type }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="来源订单" width="100" align="center">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.source_order"
              type="text"
              size="small"
              @click="showSourceOrder(scope.row)"
            >
              查看
            </el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <el-pagination
        v-if="total > 0"
        @current-change="handlePageChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="total"
        layout="total, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right"
      />
    </el-card>
    
    <!-- 来源订单对话框 -->
    <el-dialog
      title="来源订单详情"
      :visible.sync="sourceOrderDialogVisible"
      width="600px"
    >
      <pre v-if="currentSourceOrder">{{ JSON.stringify(currentSourceOrder, null, 2) }}</pre>
      <div v-else>无来源订单信息</div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DailyPaymentData',
  props: {
    // 接收父组件传递的筛选条件
    filterData: {
      type: Object,
      default: () => ({
        pindex_id: '',
        house_id: 0,
        house_address: ''
      })
    }
  },
  data() {
    return {
      searchForm: {
        stat_date: '',
        customer_name: '',
        charge_item_name: '',
        order_type: '',
        payment_method: '',
        period_type: ''
      },
      tableData: [],
      loading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableHeight: 500,
      sourceOrderDialogVisible: false,
      currentSourceOrder: null
    }
  },
  mounted() {
    this.loadData()
  },
  watch: {
    // 监听filterData变化，自动刷新数据
    filterData: {
      handler() {
        this.currentPage = 1
        this.loadData()
      },
      deep: true
    }
  },
  methods: {
    // 加载数据
    loadData() {
      this.loading = true
      
      const params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchForm,
        // 使用父组件传递的筛选条件
        pindex_id: this.filterData.pindex_id,
        house_id: this.filterData.house_id,
        house_address: this.filterData.house_address
      }
      
      this.$myhttp.post('admin/IncomeController/getListDaily', params).then(res => {
        this.loading = false
        if (res.data.code === 200) {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
        }
      }).catch(() => {
        this.loading = false
      })
    },
    
    // 搜索
    handleSearch() {
      this.currentPage = 1
      this.loadData()
    },
    
    // 重置
    handleReset() {
      this.searchForm = {
        stat_date: '',
        customer_name: '',
        charge_item_name: '',
        order_type: '',
        payment_method: '',
        period_type: ''
      }
      this.handleSearch()
    },
    
    // 分页变化
    handlePageChange(page) {
      this.currentPage = page
      this.loadData()
    },
    
    // 导出Excel
    handleExport() {
      const params = { ...this.searchForm }
      
      this.$myhttp.post('admin/IncomeController/exportExcelDaily', params, {
        'Content-Type': 'application/x-www-form-urlencoded'
      }).then(res => {
        if (res.data.code == 200) {
          let url = res.data.data.url
          window.open(this.$myhttp.defaults.baseURL + url, "_blank")
          this.$message.success('导出成功')
        } else {
          this.$message.error(res.data.message || '导出失败')
        }
      }).catch(() => {
        this.$message.error('请求异常')
      })
    },
    
    // 显示来源订单
    showSourceOrder(row) {
      try {
        this.currentSourceOrder = typeof row.source_order === 'string' 
          ? JSON.parse(row.source_order) 
          : row.source_order
        this.sourceOrderDialogVisible = true
      } catch (e) {
        this.$message.error('解析来源订单失败')
      }
    },
    
    // 格式化金额
    formatMoney(value) {
      if (value === null || value === undefined) return '0.00'
      return Number(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    
    // 获取订单类型标签颜色
    getOrderTypeTag(type) {
      const typeMap = {
        '收款': 'success',
        '红冲': 'danger',
        '预收款': 'warning',
        '押金': 'info',
        '冲销': ''
      }
      return typeMap[type] || ''
    },
    
    // 获取综合期间标签颜色
    getPeriodTypeTag(type) {
      const typeMap = {
        '历史': 'info',
        '当期': 'success',
        '预收': 'warning'
      }
      return typeMap[type] || ''
    }
  }
}
</script>

<style scoped lang="scss">
.daily-payment-data {
  .table-card {
    .text-danger {
      color: #F56C6C;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Order/income/DailyPaymentData.vue